export default __webpack_public_path__ + "static/media/market_pinpoint.a7ee6d9e.svg";